import './App.scss'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/home/Home'
import InstructorsProfile from './pages/instructors/InstructorsProfile';
import SignUpCustomer from './pages/signUpCustomer/SignUpCustomer';
import TermsAndConditions from './pages/termsAndConditions/TermsAndConditions';
import Privacy from './pages/privacy/Privacy';
import { PAGE_URLS } from './constants/hrefLinks';
import ContactUs from './pages/contactUs/ContactUs';
import FaQ from './pages/faq/FaQ';
import Page404 from './pages/404/Page404';
import LogIn from './pages/logIn/LogIn';
import Dashboard from './pages/dashboard/Dashboard';
import DashboardChat from './pages/dashboardChat/DashboardChat';
import { useCookies } from 'react-cookie';
import { useAppDispatch } from './redux/hooks';
import { useEffect, useState } from 'react';
import { userStateData } from './data/userStateData';
import { UserData } from './server/types';
import { setLoggedIn, setLoggedInChecked } from './redux/reducers/userSlice';
import CreateInteraction from './pages/createInteraction/CreateInteraction';
import DashboardProfile from './pages/dashboardProfile/DashboardProfile';
import SignUpInstructor from './pages/signUpInstructor/SignUpInstructor';
import Admin from './pages/admin/Admin';
import AdminCustomers from './pages/adminCustomers/AdminCustomers';
import AdminInstructors from './pages/adminInstructors/AdminInstructors';
import VerifyEmailPage from './pages/verifyEmail/VerifyEmail';
import VerifyInstructorEmail from './pages/verifyInstructorEmail/VerifyInstructorEmail';
import AdminInstructor from './pages/adminInstructor/AdminInstructor';
import ThankYou from './pages/thankYou/ThankYou';
import DashboardReviews from './pages/dashboardReviews/DashboardReviews';
import DashboardBookings from './pages/dashboardBookings/DashboardBookings';
import DashboardEarnings from './pages/dashboardEarnings/DashboardEarnings';
import AdminLogIn from './pages/adminLogIn/AdminLogIn';
import TransactionSuccess from './pages/transactionSuccess/TransactionSuccess';
import TransactionIssue from './pages/transactionIssue/TransactionIssue';
import ResetPassword from './pages/resetPassword/ResetPassword';
import PasswordReset from './pages/passwordReset/PasswordReset';
import LandingPage from './pages/landingPage/LandingPage';
import AdminChats from './pages/adminChats/AdminChats';
import AdminChat from './pages/adminChat/AdminChat';
import DashboardVideoAnalysis from './pages/dashboardVideoAnalysis/DashboardVideoAnalysis';
import AppLogIn from './pages/app_logIn/AppLogIn';
import AppSignUp from './pages/app_signUp/AppSignUp';
import AppPasswordReset from './pages/app_passwordReset/AppPasswordReset';
import AppInstructorProfile from './pages/app_instructor/AppInstructorProfile';
import AppInstructorProfilePics from './pages/app_instructorPics/AppInstructorProfilePics';
import AppExplore from './pages/app_explore/AppExplore';
import { windowResize } from './redux/reducers/resizeSlice';
import AppEntry from './pages/app_entry/AppEntry';
import AppSettings from './pages/app_settings/AppSettings';
import AppProfile from './pages/app_profile/AppProfile';
import AppProfileUser from './pages/app_profileUser/AppProfileUser';
import AppCommunity from './pages/app_community/AppCommunity';
import AppCommunities from './pages/app_communities/AppCommunities';
import AppLessons from './pages/app_lessons/AppLessons';
import AppResetPassword from './pages/app_resetPassword/AppResetPassword';

function App() {
	const [cookies] = useCookies()
	const dispatch = useAppDispatch()

	const [logInChecked, setLogInChecked] = useState<boolean>(false)

	useEffect(() => {
		getUserData()
		addResizeHandler()
	}, [])

	const addResizeHandler = () => {
		window.addEventListener('resize', () => {
			dispatch(windowResize())
		})
		dispatch(windowResize())
	}

	const getUserData = () => {
		if (cookies?.userData) {
			userStateData.setUserData(cookies.userData as UserData)
		}
		// if (userStateData.loggedIn === true) {
		// }
		dispatch(setLoggedIn(userStateData.loggedIn === true))
		dispatch(setLoggedInChecked(true))
		setLogInChecked(true)
		// setIsLoggedIn(userStateData.loggedIn === true)
	}
	
	return (
		<>
			{logInChecked === true &&
				<BrowserRouter>
					<Routes>
						<Route path="/">
							{/* <Route index element={<Home />} /> TEMP: redirect to sign up page for soft release */}
							{/* <Route index element={<SignUpInstructor />} /> */}
							{/* <Route index element={<LandingPage />} /> */}
							<Route index element={<AppEntry />} />
							
							<Route path={PAGE_URLS.SEARCH} element={<Home />} />

							<Route path={PAGE_URLS.SIGN_UP} element={<SignUpCustomer />} />
							<Route path={PAGE_URLS.SIGN_UP_INSTRUCTOR} element={<SignUpInstructor />} />
							<Route path={PAGE_URLS.THANK_YOU} element={<ThankYou />} />
							<Route path={PAGE_URLS.VERIFY_EMAIL} element={<VerifyEmailPage />} />
							<Route path={PAGE_URLS.VERIFY_INSTRUCTOR_EMAIL} element={<VerifyInstructorEmail />} />
							<Route path={PAGE_URLS.LOG_IN} element={<LogIn />} />
							
							<Route path={PAGE_URLS.RESET_PASSWORD} element={<ResetPassword />} />
							<Route path={PAGE_URLS.PASSWORD_RESET} element={<PasswordReset />} />

							<Route path={PAGE_URLS.CONTACT_US} element={<ContactUs />} />
							<Route path={PAGE_URLS.FAQ} element={<FaQ />} />

							<Route path={PAGE_URLS.PRIVACY} element={<Privacy />} />
							<Route path={PAGE_URLS.TERMS_AND_CONDITIONS} element={<TermsAndConditions />} />

							<Route path={PAGE_URLS.INSTRUCTOR} element={<InstructorsProfile />} />

							<Route path={PAGE_URLS.CREATE_NEW_CHAT} element={<CreateInteraction />} />

							<Route path={PAGE_URLS.TRANSACTION_SUCCESS} element={<TransactionSuccess />} />
							<Route path={PAGE_URLS.TRANSACTION_FAILED} element={<TransactionIssue />} />

							<Route path={PAGE_URLS.DASHBOARD_CUSTOMER} element={<Dashboard />} />
							<Route path={PAGE_URLS.DASHBOARD_PROFILE} element={<DashboardProfile />} />
							<Route path={PAGE_URLS.DASHBOARD_CHAT} element={<DashboardChat />} />
							<Route path={PAGE_URLS.DASHBOARD_REVIEWS} element={<DashboardReviews />} />
							<Route path={PAGE_URLS.DASHBOARD_BOOKINGS} element={<DashboardBookings />} />
							<Route path={PAGE_URLS.DASHBOARD_EARNINGS} element={<DashboardEarnings />} />

							<Route path={PAGE_URLS.DASHBOARD_TOOL} element={<DashboardVideoAnalysis />} />
							
							<Route path={PAGE_URLS.ADMIN} element={<Admin />} />
							<Route path={PAGE_URLS.ADMIN_LOGIN} element={<AdminLogIn />} />
							<Route path={PAGE_URLS.ADMIN_ALL_CUSTOMERS} element={<AdminCustomers />} />
							<Route path={PAGE_URLS.ADMIN_ALL_INSTRUCTOR} element={<AdminInstructors />} />
							<Route path={PAGE_URLS.ADMIN_INSTRUCTOR} element={<AdminInstructor />} />
							<Route path={PAGE_URLS.ADMIN_CHATS} element={<AdminChats />} />
							<Route path={PAGE_URLS.ADMIN_CHAT} element={<AdminChat />} />

							<Route path={PAGE_URLS.APP_ENTRY} element={<AppEntry />} />

							<Route path={PAGE_URLS.APP_LOGIN} element={<AppLogIn />} />
							<Route path={PAGE_URLS.APP_SIGN_UP} element={<AppSignUp />} />
							<Route path={PAGE_URLS.APP_PASSWORD_RESET} element={<AppPasswordReset />} />
							<Route path={PAGE_URLS.APP_RESET_PASSWORD} element={<AppResetPassword />} />

							<Route path={PAGE_URLS.APP_EXPLORE} element={<AppExplore />} />

							<Route path={PAGE_URLS.APP_LESSONS} element={<AppLessons />} />

							<Route path={PAGE_URLS.APP_COMMUNITIES} element={<AppCommunities />} />
							<Route path={PAGE_URLS.APP_COMMUNITY} element={<AppCommunity />} />

							<Route path={PAGE_URLS.APP_PROFILE} element={<AppProfile />} />
							<Route path={PAGE_URLS.APP_PROFILE_USER} element={<AppProfileUser />} />
							<Route path={PAGE_URLS.APP_SETTINGS} element={<AppSettings />} />

							<Route path={PAGE_URLS.APP_INSTRUCTOR} element={<AppInstructorProfile />} />
							<Route path={PAGE_URLS.APP_INSTRUCTOR_PICS} element={<AppInstructorProfilePics />} />
							
							<Route path="*" element={<Page404 />} />
						</Route>
					</Routes>
				</BrowserRouter>
			}
		</>
	)
}

export default App
